import galaxsysService from '../services/galaxsys.service'

const handlers = {
  galaxsys: {
    session: {
      set: 'galaxsys_session_set'
    }
  }
}

const initVuexState = function(state) {
  state.galaxsys = {
    session: null
  };
}

const initGetters = function(getters) {
  getters.galaxsys = (state => state.galaxsys);
}

const initActions = function(actions) {
  actions[handlers.galaxsys.session.set] = ({ commit }, session) => commit(handlers.galaxsys.session.set, session);
}

const initMutations = function(mutations) {
  mutations[handlers.galaxsys.session.set] = (state, session) => state.galaxsys.session = session;
}

const initAppState = function(appState, store) {
  appState.galaxsys = {
    session: {
      get: () => store.getters.galaxsys.session,
      open: async (gameId, language, isMobile) => {
        let session = await galaxsysService.openSession(gameId, language, isMobile);
        store.dispatch(handlers.galaxsys.session.set, session);
      },
      openDemo: async (gameId, language, isMobile) => {
        let session = await galaxsysService.openDemoSession(gameId, language, isMobile);
        store.dispatch(handlers.galaxsys.session.set, session);
      },
      close: async () => {
        if (store.getters.galaxsys.session) {
          await galaxsysService.closeSession();
        }
        store.dispatch(handlers.galaxsys.session.set, null);
      }
    }
  }
}

export default {
  initVuex(vuexState, getters, actions, mutations) {
    initVuexState(vuexState);
    initGetters(getters);
    initActions(actions);
    initMutations(mutations);
  },
  initAppState(appState, store) {
    initAppState(appState, store);
  }
}



// WEBPACK FOOTER //
// ./_common/data/galaxsys.js